import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  ReportAttendanceResponse,
  ReportLeaveResponse,
  ReportOverTimeRequest,
  ReportOverTimeResponse,
  ReportPITSummaryRequest,
  ReportPITSummaryResponse,
  ReportPayrollSummaryRequest,
  ReportPayrollSummaryResponse,
  ReportReconcileRequest,
  ReportReconcileResponse,
  ReportSHUIContributionRequest,
  ReportSHUIContributionResponse,
  ReportOneStream,
  EmployeeProfile,
  Diligence,
  ReportLaborManagementBookRequest,
  ReportLaborManagementBookResponse,
} from "./types";

export const reportOverTimeService = (params: ReportOverTimeRequest) =>
  RestAPIClient.call<ReportOverTimeResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ReportOvertime,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const reportAttendanceService = (params: ReportOverTimeRequest) =>
  RestAPIClient.call<ReportAttendanceResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ReportAttendance,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const reportLeaveService = (params: ReportOverTimeRequest) =>
  RestAPIClient.call<ReportLeaveResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ReportLeave,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const reportReconcileService = (params: ReportReconcileRequest) =>
  RestAPIClient.call<ReportReconcileResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ReportReconcile,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const reportPayrollSummaryService = (
  params: ReportPayrollSummaryRequest
) =>
  RestAPIClient.call<ReportPayrollSummaryResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ReportPayrollSummary,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const reportSHUIContributionService = (
  params: ReportSHUIContributionRequest
) =>
  RestAPIClient.call<ReportSHUIContributionResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ReportSHUIContribution,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const reportPITSummaryService = (params: ReportPITSummaryRequest) =>
  RestAPIClient.call<ReportPITSummaryResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ReportPITSummary,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const reportOneStreamService = (params: {
  page?: number | null;
  limit?: number | null;
  month?: number | null;
  year?: number | null;
  notCount?: boolean;
}) =>
  RestAPIClient.call<ReportOneStream[]>({
    method: HTTPRequestMethods.GET,
    url: Paths.ReportOneStream,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const reportEmployeeProfileService = ({ id }: { id: number }) =>
  RestAPIClient.call<EmployeeProfile>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.ReportEmployeeProfile.replace("{id}", id.toString())}`,
    config: {
      requireAuthentication: true,
    },
  });

export const reportDiligenceService = (params: {
  page?: number | null;
  limit?: number | null;
  fromMonth: string;
  toMonth: string;
  templateId: string;
  templateFieldCode?: string;
  year: number;
  notCount?: boolean;
  empCodes?: string[];
  deptIds?: number[];
}) =>
  RestAPIClient.call<Diligence[]>({
    method: HTTPRequestMethods.GET,
    url: Paths.ReportDiligence,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const reportLaborManagementBookService = (
  params: ReportLaborManagementBookRequest
) =>
  RestAPIClient.call<ReportLaborManagementBookResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ReportLaborManagementBook,
    config: {
      requireAuthentication: true,
      params,
    },
  });
